export class Message {
    Identifier: string;
    Content: string;
}